module.exports = __webpack_public_path__ + "static/flags/IM-1649dfeb7679a50e061450e7603178c5.gif";